import "../../../libs/backbone/backbone.ajaxq.adapter.ts";
import GenericView from '../generic.view.ts';
import Handlebars from 'handlebars';
import Template from 'text-loader!../../templates/settings.template.html';
import i18n  from "l10n";
import popup from "popup";

export default GenericView.extend({
    tagName: 'div',
	template: Handlebars.compile(Template),
	defaultOptions: {
        "url": null,
        "type": null, // POST | GET | PUT | DELETE
        "data": null, // the data to pass to the request
        "successMessage": "", // a message to display, when the request was successful
        "errorMessage":  "", // a message to display, when the request was unsuccessful,
        "_cancelBtn": null, // a jQuery selector, of the "cancel" button -- $('#cancelBtn')
        "_actionButton": null // a jQuery selector, of the "action" button -- Used to display SUCCESS or ERROR messages, on that button
	},
	initialize: function (options) {
		var self = this;

		if(options) {
            this.popupParams = $.extend({}, this.defaultOptions, options.popupOptions);
            this.popupTypeOptions = options.popupTypeOptions;

            if(popup.isShown())
                popup.hide();

            popup.show(this.popupTypeOptions.title, this.popupTypeOptions.content, this.popupTypeOptions.type, this.popupParams);
        }
	},
	superRender: GenericView.prototype.render,
	render: function () {
		var self = this;

		this.superRender();

		this.$el.html(this.template( {privilegeLevel: this.numberPrivilegeLevel}));

		return this;
	},
	events:{

	}
});

